<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">Bülten Listesi</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :lg="16" :md="16" :sm="24" :xs="24">
                <div>
                    <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                    text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-bullhorn mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='1'">{{$t("src.views.apps.haberler.liste.yayinda")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-bullhorn mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='0'">{{$t("src.views.apps.haberler.liste.pasif")}}</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :lg="8" :md="8" :sm="24" :xs="24">
                <div class="flex">
                    <div class="daireclass margin-left-10"></div>
                    <div class="margin-left-5">Oluşturan</div>
                    <div class="daireclass1 margin-left-10"></div>
                    <div class="margin-left-5">Bülten Detay</div>
                    <div class="daireclass2 margin-left-10"></div>
                    <div class="margin-left-5">Bülten Düzenle</div>
                    <div v-if="selectIcon==='1'" class="daireclass3 margin-left-10"></div>
                    <div v-if="selectIcon==='1'" class="margin-left-5">Yayından Kaldır</div>
                    <div v-if="selectIcon==='0'" class="daireclass4 margin-left-10"></div>
                    <div v-if="selectIcon==='0'" class="margin-left-5">Yayına Al</div>
                </div>
                <el-tooltip :content='$t("src.views.apps.haberler.tanimlama.title")'
                            :open-delay="500"
                            placement="bottom">
                    <el-button
                            v-on:click="routeBulten('Bülten Tanımla')"
                            style="float: right; margin-top: -25px"
                            size="mini"
                            icon="el-icon-plus">
                    </el-button>
                </el-tooltip>
            </el-col>
            <el-table
                    :data="haberlerList.filter(data => !search.baslik || data.baslik.toLowerCase().includes(search.baslik.toLowerCase()) )"
                    ref="filterTable"
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        v-if="!index"
                        :filters="filtersKategori"
                        :filter-method="filterTag"
                        filter-placement="bottom-end"
                        prop="kategoriAdi"
                        label="Kategori"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tag
                                type="primary"
                                disable-transitions>{{scope.row.kategoriAdi}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Resim"
                        width="auto">
                    <template slot-scope="scope">
                        <el-popover
                                transition="el-fade-in-linear"
                                placement="left"
                                width="auto"
                                trigger="hover">
                            <img v-if="scope.row.resim" :src="imagepath+scope.row.resim"
                                 :alt="scope.row.baslik">
                            <i style="font-size: 24px; cursor: pointer; color: #337ab7" slot="reference"
                               class="el-icon-picture"></i>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="baslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="sayac"
                        label="Sayaç"
                        width="auto">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="olusumTarihi"
                        label="Yayın Tarihi"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot="header" slot-scope="scope">
                        <input
                                class="searchClass"
                                v-model="search.baslik"
                                @input="forceUpper($event, search, 'baslik')"
                                size="mini"
                                placeholder="Ara"/>
                    </template>
                    <template slot-scope="scope">
                        <el-tooltip :content='scope.row.olusturan' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    style="color: #64b1e2"
                                    type="text"
                                    icon="mdi mdi-account mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.haberler.liste.haberdetay")' :open-delay="500"
                                    placement="bottom">
                            <el-link target="_blank" class="margin-bottom-7" icon="mdi mdi-redo-variant mdi-24px"
                                     :underline="false" :href="path+scope.row.link">
                            </el-link>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.haberler.liste.haberlerduzenle")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="root || yetkiList.haberGuncelle"
                                    v-on:click="routeBulten('Bülten Düzenle',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.haberler.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='1' && (root || yetkiList.haberSil)"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    size="mini"
                                    class="buttonDel"
                                    type="text"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.sayfa.liste.yayindanKaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='0' && (root || yetkiList.haberSil)"
                                    @click="haberDurumChange(scope.row,scope.$index,haberlerList,1)"
                                    type="text"
                                    icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>"{{selection.baslik}}" {{$t('src.views.apps.haberler.liste.haberlerYayin')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="haberDurumChange(selection,selectionIndex,haberlerList,0), deleteDialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import haberlerService from '../../../WSProvider/HaberService'
    import notification from '../../../notification'

    var moment = require('moment');

    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: "HaberlerListe",
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataSidas")) {
                userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
                if (userDataSidas["tur"]) {
                    if (userDataSidas["tur"] === '1' || userDataSidas["tur"] === '2') {
                        self.root = true;
                        self.yetkiList.haberSil = true;
                        self.yetkiList.haberGuncelle = true;
                    }
                } else if (userDataSidas["yetki"]) {
                    userDataSidas["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-863391':
                                self.yetkiList.haberGuncelle = true;
                                self.yetkiList.haberSil = true;
                                break;
                            case 'YK-410578':
                                self.yetkiList.haberSil = true;
                                break;
                        }
                    });
                }

            }
            this.haberlerCount();
            this.getHaberList();
        },
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                root: false,
                yetkiList: {
                    haberGuncelle: false,
                    haberSil: false,
                },
                path: haberlerService.path,
                search: {
                    baslik: ''
                },
                search2: {
                    baslik: ''
                },
                imagepath: haberlerService.imageUrlKucuk,
                index: '',
                dil: 'tr',
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                deleteDialogVisible: false,
                selection: '',
                selectionIndex: '',
                haberlerList: [],
                filtersKategori: [],
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getHaberList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getHaberList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getHaberList();
                this.haberlerCount();
            },
            forceUpper(e, o, prop) {
                const start = e.target.selectionStart;
                e.target.value = e.target.value.toUpperCase();
                this.$set(o, prop, e.target.value);
                e.target.setSelectionRange(start, start);
            },
            filterTag(value, row) {
                return row.kategoriKodu === value;
            },
            haberlerCount() {
                haberlerService.haberCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data.count);
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            getHaberList() {
                let self = this;
                haberlerService.haberListDetay(this.index, this.postPage, this.sizes, this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            e.olusumTarihi = moment(e.olusumTarihi).format('DD-MM-YYYY HH:mm:ss');
                            var obj2 = self.filtersKategori.find(data => data.value === e.kategoriKodu);
                            if (obj2 === undefined) {
                                self.filtersKategori.push({
                                    text: e.kategoriAdi,
                                    value: e.kategoriKodu
                                })
                            }
                        });
                        self.haberlerList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            routeBulten(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.haberKodu);
                }
                var header = linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            },
            haberDurumChange(selection, index, list, durum) {
                haberlerService.haberDurumGuncelle(selection.haberKodu, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case 0:
                                notification.Status("success", this, "Haber Taslağa Taşındı.");
                                list.splice(index, 1);
                                break;
                            case 1:
                                notification.Status("success", this, "Haber Yayına Alındı.");
                                list.splice(index, 1);
                                break;
                            case 2:
                                notification.Status("success", this, "Haber Arşive Taşındı.");
                                list.splice(index, 1);
                                break;
                        }

                    }
                })
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>


<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>